import React from "react";
import styled from "styled-components";
import {Grid, Col} from "../../styles/Grid";
import {TextArea} from "../../styles/Forms";
import {AppButton, ButtonWithIcon} from "../../styles/Butttons";
import {Label} from "../forms/DynamicInput";
import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";
import EditableImg from "../forms/EditableImg";
import parse from "html-react-parser";

export default function ToogleForm({editable, save, data, titleDesc, change, video, viewTitle}) {
   return (
      <>
         {editable ? (
            <EditMode data={data} titleDesc={titleDesc} save={save} video={video} viewTitle={viewTitle} />
         ) : (
            <ReadMode data={data} changeEdit={change} titleDesc={titleDesc} video={video} viewTitle={viewTitle} />
         )}
      </>
   );
}

const EditMode = ({data, titleDesc, viewTitle, save, video}) => {
   if (!data) return null;
   return (
      <>
         <SecBody onSubmit={save} as="form">
            <Grid>
               <Col large="12">
                  <Label className="labelMargin">{titleDesc}:</Label>
               </Col>
               <Col large="9">
                  <TextArea
                     as="textarea"
                     defaultValue={data.description ? data.description.replace(/<br>/g, "\n") : ""}
                     name="description"
                  ></TextArea>
               </Col>
               <Col large="12" />
            </Grid>
            <Grid>
               <Col large="12">
                  <Label className="labelTitle">{video ? "Video/Imagen de portada" : "Imagen de portada"}</Label>
               </Col>
               {video && (
                  <Col large="12">
                     <Grid>
                        <Col large="6">
                           <EditableImg
                              type="video"
                              name={`video${viewTitle}`}
                              fileName={data.pathImageWebMobile}
                              editable={true}
                              title="Video"
                              label="Video"
                           />
                        </Col>
                     </Grid>
                  </Col>
               )}
               <div className="division" />
               <Col large="12">
                  <Grid>
                     <Col large="6">
                        <EditableImg
                           name={`desk${viewTitle}`}
                           fileName={data.pathImageWebDesktop}
                           editable={true}
                           title="Desktop"
                           label="Desktop medidas aprox 1024px X 768px"
                        />
                     </Col>
                     <Col large="6">
                        <EditableImg
                           name={`mobile${viewTitle}`}
                           fileName={data.pathImageWebMobile}
                           editable={true}
                           title="Mobile"
                           label="Mobile medidas aprox 510px X 428px"
                        />
                     </Col>
                  </Grid>
               </Col>
               <Col large="2" offsetL="10" style={{marginTop: "1.5em"}}>
                  <AppButton>GUARDAR</AppButton>
               </Col>
            </Grid>
         </SecBody>
      </>
   );
};

const ReadMode = ({data, titleDesc, viewTitle, changeEdit, video}) => {
   if (!data) return null;
   return (
      <>
         <SecBody>
            <Grid>
               <Col large="12">
                  <Label className="labelMargin">{titleDesc}:</Label>
               </Col>
               <Col large="11">
                  <Label className="labelText">{parse(data.description) || "Ingresa una descripción o texto"}</Label>
               </Col>
               <Col large="1">
                  <ButtonWithIcon text="" Icon={EditIcon} right={true} action={changeEdit} />
               </Col>
            </Grid>
         </SecBody>
         <SecBody>
            <Grid>
               <Col large="12">
                  <Label className="labelTitle">{video ? "Video/Imagen de portada" : "Imagen de portada"}</Label>
               </Col>
               {video && (
                  <Col large="12">
                     <Grid>
                        <Col large="6">
                           <EditableImg
                              name={`mobile${viewTitle}`}
                              fileName={data.pathVideo}
                              editable={false}
                              title="Video"
                              label="Video"
                           />
                        </Col>
                     </Grid>
                  </Col>
               )}
               <div className="division" />
               <Col large="12">
                  <Grid>
                     <Col large="6">
                        <EditableImg
                           name={`desk${viewTitle}`}
                           fileName={data.pathImageWebDesktop}
                           editable={false}
                           title="Desktop"
                           label="Desktop medidas aprox 1024px X 768px"
                        />
                     </Col>
                     <Col large="6">
                        <EditableImg
                           name={`mobile${viewTitle}`}
                           fileName={data.pathImageWebMobile}
                           editable={false}
                           title="Mobile"
                           label="Mobile medidas aprox 510px X 428px"
                        />
                     </Col>
                  </Grid>
               </Col>
            </Grid>
         </SecBody>
      </>
   );
};

const SecBody = styled.div`
   padding: 1em;
   // margin-bottom: 1em;
   border-bottom: 1px solid rgba(100, 100, 100, 0.3);

   .labelMargin {
      margin-bottom: 1em;
   }
   .labelTitle {
      font-size: 1.2em;
      margin-bottom: 1em;
   }
   .labelText {
      font-weight: 400;
   }

   .division {
      width: 100%;
      margin-bottom: 2em;
   }
`;
